import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rejectedModalBodyText: {
    description: 'Message asking the user to select a reason for the cancelation of a fulfillment.',
    defaultMessage:
      'The selected fulfillments will be rejected and sent back to the client. The client will be notified and can decide how to proceed. To help the client, please choose a reason for rejection.',
    id: '+Afgu7',
  },
  warning: {
    description: 'Warning text to let the user know the same Rejection Reason will apply to all cancellations.',
    defaultMessage: 'You’ve selected fulfillments from multiple clients. This same reason will be sent to all of them.',
    id: 'HQSvKZ',
  },
  mixOrders: {
    description: 'Info text to let the user know that they selected client delegated orders and non client delegated orders.',
    defaultMessage: 'You have some orders that have been delegated to you, for these please select a Rejection Reason.',
    id: 'a8JFYF',
  },
  modalHeader: {
    description: 'Header for Cancel Modal when rejecting client delegated orders',
    defaultMessage: 'Reject Fulfillment',
    id: 'Cq0ySp',
  },
  dropdownHeader: {
    description: 'Header on top of drop down menu',
    defaultMessage: 'Rejection Reason',
    id: 'l7deEF',
  },
  dropdownPlaceholder: {
    description: 'Placeholder for rejection reason drop down options',
    defaultMessage: 'Select a reason…',
    id: 'i7PSGF',
  },
  cancelButtonText: {
    description: 'Button text to cancel the process of rejecting a fulfillment',
    defaultMessage: 'Don’t Reject',
    id: 'Pv5UU/',
  },
  continueButtonText: {
    description: 'Button text to continue with Rejection of selected fulfillments',
    defaultMessage: 'Reject Fulfillment',
    id: 'PZzzLG',
  },
  bulkRejectfulfilmentTitle: {
    description: 'Header for Reject Fulfillments type notifications',
    defaultMessage: 'Reject',
    id: '16C/c4',
  },
  bulkRejectFulfillmentProcessingMessage: {
    description: 'Message for Reject Fulfillments Processing type notifications',
    defaultMessage: 'Rejecting {fulfillmentsCancelled, plural, one {# fulfillment} other {# fulfillments}}...',
    id: '6DFZ/u',
  },
  bulkRejectFulfillmentSuccessMessage: {
    description: 'Message for Reject Fulfillments Success type notifications',
    defaultMessage: 'Successfully rejected {fulfillmentsCancelled, plural, one {# fulfillment} other {# fulfillments}}',
    id: 'aiuVyX',
  },
  bulkRejectFulfillmentErrorMessage: {
    description: 'Message for Reject Fulfillments Error type notifications',
    defaultMessage: 'Could not reject fulfilments at this time. Please try again.',
    id: 'o85KOL',
  },
});
